import {useEffect, useState} from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {Autoplay, Navigation, Pagination} from "swiper/modules";
const NewsRightPanelComponent = () => {
    const [data,setData] = useState([]);

    const getData = () => {
        axios.get("https://ileti.orbel.com.tr/ordubelapi/").then(res => {
            setData(res.data)
        }).catch(err => {})
    }

    useEffect(() => {
        getData()

        const intervalId = setInterval(() => {
            getData();
        }, 1200000);

        // Unmounting logic
        return () => {
            clearInterval(intervalId);
        };
    }, []);
    return(<div className={"news-widget"}>

        <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
                delay: 10000,
                disableOnInteraction: false,
            }}
            pagination={{
                clickable: true,
            }}
            navigation={true}

            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
        >
            {data.map((item,index) => {
                return(<SwiperSlide className={"news-detail"} key={item.id} id={item.id}>
                        <div className={"news-image"}
                             style={{backgroundImage: `url('${item.image}')`}}>
                        </div>
                        <div className={"news-title"}>
                            <p>{item.title}</p>
                        </div>
                        <div className={"news-desc"}>
                            <p>{item.description}</p>
                        </div>
                        <div className={"news-share"}>
                            <div className={"news-share-title"}>
                                Haberlerin detayları www.ordu.bel.tr adresinde...
                            </div>
                        </div>
                </SwiperSlide>)
            })}
        </Swiper>

    </div>)
}

export default NewsRightPanelComponent
